import React from 'react'
import styled from 'styled-components'
import {
  color,
  flexbox,
  grid,
  layout,
  position,
  space,
  system,
  typography,
  borderRadius,
  display,
  overflow
} from 'styled-system'
import shouldForwardProp from '@styled-system/should-forward-prop'

export const gap = system({
  gap: {
    property: 'gap',
    scale: 'space'
  }
})

export const Box = styled('div')
  .withConfig({
    shouldForwardProp
  })
  .attrs(props => ({
    display: 'block',
    position: 'relative',
    ...props
  }))(
  {},
  space,
  layout,
  color,
  grid,
  position,
  typography,
  borderRadius,
  display,
  overflow
)

export const Flex = styled('div')
  .withConfig({
    shouldForwardProp
  })
  .attrs(props => ({
    display: 'flex',
    position: 'relative',
    ...props
  }))(
  {},
  space,
  layout,
  color,
  flexbox,
  grid,
  position,
  gap,
  typography,
  borderRadius,
  display,
  overflow
)

export const Grid = styled('div')
  .withConfig({
    shouldForwardProp
  })
  .attrs(props => ({
    display: 'grid',
    position: 'relative',
    ...props
  }))(
  {},
  space,
  layout,
  color,
  flexbox,
  grid,
  position,
  gap,
  typography,
  borderRadius,
  display,
  overflow
)

export const LayoutGrid = styled('section')
  .withConfig({
    shouldForwardProp
  })
  .attrs(props => ({
    display: 'grid',
    position: 'relative',
    gridColumnGap: 4,
    alignItems: 'center',
    justifyContent: 'center',
    gridTemplateColumns: [
      'repeat(6, 1fr)',
      'repeat(6, 1fr)',
      'repeat(6, 1fr)',
      'repeat(12, 1fr)'
    ],
    gridAutoRows: 'auto',
    ...props
  }))(
  {},
  space,
  layout,
  color,
  flexbox,
  grid,
  position,
  gap,
  typography,
  borderRadius,
  display,
  overflow
)

export const Hide = ({ xs, s, m, l, children, ...props }) => {
  return (
    <Flex
      display={[
        xs ? 'none' : 'flex',
        s ? 'none' : 'flex',
        m ? 'none' : 'flex',
        l ? 'none' : 'flex'
      ]}
      {...props}
    >
      {children}
    </Flex>
  )
}
